import { assetUrl, webpUrl } from "@/lib/api";

export const Picture = ({ src, alt, lazy = false, ...rest }) => {
  const webp = webpUrl(src);
  const img = (
    <img
      src={assetUrl(src)}
      alt={alt}
      loading={lazy ? "lazy" : undefined}
      decoding={lazy ? "async" : undefined}
      {...rest}
    />
  );
  if (!webp) return img;
  return (
    <picture>
      <source type="image/webp" srcSet={webp} />
      {img}
    </picture>
  );
};
